"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var creator_ui_1 = require("@chameleoncreator/creator-ui");
exports.Header = function (_a) {
    var children = _a.children, sticky = _a.sticky;
    return (react_1.default.createElement(creator_ui_1.Flexbox, { style: { position: "sticky", top: 0 }, bg: "#fff", color: "#333", p: "10px", borderBottom: "1px solid #eee", zIndex: "1000", boxShadow: "1px 1px 20px 0 rgba(0,0,0,0.2)", alignItems: "center" }, children));
};
exports.Header.displayName = "Header";
